import React from 'react';
import { LuMapPin, LuPhone, LuMail } from 'react-icons/lu';
import { FaInstagram, FaFacebookF, FaTiktok } from 'react-icons/fa6';
import './Footer.css';

export default function Footer({ navigate }) {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">
            <div className="footer-logo">
              <img src="/logo.png" alt="Cardona Auto Detailing" className="footer-logo-img" />
            </div>
          </div>
          <p className="footer-tagline">Premium mobile detailing —<br />we come to you.</p>
        </div>

        <div className="footer-col">
          <h4>Navigation</h4>
          <ul>
            {['home', 'about', 'services', 'reviews', 'contact'].map(p => (
              <li key={p}>
                <button onClick={() => navigate(p)}>
                  {p.charAt(0).toUpperCase() + p.slice(1)}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            <li><span>Exterior Wash &amp; Wax</span></li>
            <li><span>Interior Deep Cleaning</span></li>
           
            <li><span>Ceramic Coating</span></li>
            <li><span>Engine Bay Cleaning</span></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <ul className="footer-contact">
            <li><LuMapPin className="footer-contact-icon" aria-hidden="true" /><span>Cookville, Algood</span></li>
            <li><LuPhone className="footer-contact-icon" aria-hidden="true" /><a href="tel:+19313106581">(931) 310-6581</a></li>
            <li><LuMail className="footer-contact-icon" aria-hidden="true" /><a href="mailto:owner@cardonaautodetailing.com">owner@cardonaautodetailing.com</a></li>
          </ul>
          <button className="btn-primary footer-cta" onClick={() => navigate('reservations')}>
            Book Appointment
          </button>
        </div>
      </div>

      <div className="footer-bottom container">
        <p>© {new Date().getFullYear()} Cardona Auto Detailing. All rights reserved.</p>
        <div className="footer-social">
          <a href="https://www.instagram.com/cardonaautodetailingtn/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram aria-hidden="true" /></a>
          <a href="https://www.facebook.com/profile.php?id=61591680082145" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF aria-hidden="true" /></a>
          <a href="#tiktok" aria-label="TikTok"><FaTiktok aria-hidden="true" /></a>
        </div>
      </div>
    </footer>
  );
}
